import type { FieldMetadataBase } from 'models/forms/fields/FieldMetadataBase';
import type { UpdateAction } from 'state/formData';

export type AreSameTypePredicate<Metadata> = (firstField: Metadata, secondField: Metadata) => boolean;
export type FieldHandler = {
  isHandled: (field: FieldMetadataBase<string>) => boolean;
};
export type FieldFormatter<Metadata> = FieldHandler & {
  areSameType?: AreSameTypePredicate<Metadata>;
  merge?: (firstField: Metadata, secondField: Metadata) => Metadata;
  withDefault?: (field: Metadata) => Metadata;
  format?: (field: Metadata) => Metadata;
};

export type FieldValueEnricher<T> = FieldHandler & {
  generateEnrichment: (action: UpdateAction, target: T, changes: T) => T;
};

export type FieldValueValidator<Metadata, Value = unknown> = FieldHandler & {
  validateValue: (value: Value, field: Metadata) => boolean;
};

export const isHandledBySamePredicate =
  <Metadata>(predicate: (field: Metadata) => boolean): AreSameTypePredicate<Metadata> =>
  (firstField, secondField) =>
    predicate(firstField) && predicate(secondField);

export type FieldDefaulter<Metadata> = {
  withDefault: (field: Metadata) => Metadata;
};
